if (!customElements.get('out-of-stock-form')) {

  customElements.define(
    'out-of-stock-form',

    class OutOfStockForm extends HTMLElement {


      constructor() {

        super();

        this.cacheDOMElements();

        this.onClickBound =
          this.onClick.bind(this);

        this.onSubmitBound =
          this.onSubmit.bind(this);

      }



      cacheDOMElements() {

        this.formRevealLink =
          this.querySelector('[data-form-reveal-link]');


        this.formInputWrapper =
          this.querySelector('[data-form-input-wrapper]');


        // ONLY this notify form inside component

        this.form =
          this.querySelector('form');

      }




      connectedCallback() {

        this.attachEventListeners();

      }




      disconnectedCallback() {


        if (this.formRevealLink) {

          this.formRevealLink.removeEventListener(
            'click',
            this.onClickBound
          );

        }


        if (this.form) {

          this.form.removeEventListener(
            'submit',
            this.onSubmitBound
          );

        }

      }






      attachEventListeners() {


        if (this.formRevealLink) {

          this.formRevealLink.addEventListener(
            'click',
            this.onClickBound
          );

        }


        if (this.form) {

          this.form.addEventListener(
            'submit',
            this.onSubmitBound
          );

        }


      }







      onClick(event) {


        event.preventDefault();


        if (!this.formInputWrapper) {
          return;
        }


        this.formInputWrapper.style.display =
          this.formInputWrapper.style.display === 'none'
          ?
          'flex'
          :
          'none';


      }








      async onSubmit(event) {


        // prevent only notify form

        event.preventDefault();



        let emailInput =
          this.form.querySelector('[name="contact[email]"]');


        if (!emailInput || !emailInput.value) {

          return;

        }



        let productInput =
          this.form.querySelector('[name="klaviyo_product"]');


        let variantInput =
          this.form.querySelector('[name="klaviyo_variant"]');


        let urlInput =
          this.form.querySelector('[name="klaviyo_url"]');





        try {


          let response = await fetch(

            "https://a.klaviyo.com/client/subscriptions/?company_id=VPgFJK",

            {

              method: "POST",


              headers: {

                "Content-Type": "application/json",

                "revision": "2024-02-15"

              },



              body: JSON.stringify({


                data: {


                  type: "subscription",



                  attributes: {


                    custom_source:
                      "Shopify Notify Me Form",



                    profile: {


                      data: {


                        type: "profile",



                        attributes: {


                          email:
                            emailInput.value,



                          properties: {


                            notify_product:
                              productInput ? productInput.value : '',


                            notify_variant:
                              variantInput ? variantInput.value : '',


                            notify_product_url:
                              urlInput ? urlInput.value : ''


                          }


                        }


                      }


                    }


                  },



                  relationships: {


                    list: {


                      data: {


                        type: "list",

                        id: "TrSxVM"


                      }


                    }


                  }


                }


              })


            }


          );



          console.log(
            "Klaviyo Status:",
            response.status
          );



        } catch (error) {


          console.log(
            "Klaviyo Error:",
            error
          );


        }





        // continue original Shopify contact submit

        setTimeout(() => {


          HTMLFormElement.prototype.submit.call(this.form);


        }, 800);



      }




    }

  );

}